import { toggleModalAction } from '../../store/actions/filtersActions';
import BaseModal from '../layout/BaseModal';
import BooksFilters from './BooksFilters';
import EngBooks from './EngBooks';
import React, {Component} from 'react'
import {connect} from 'react-redux';
import FridaySermonFilters from './FridaySermonFilters';
import { LocalizationContext } from '../../localizationContext';
import langdata from '../../constants/langdata';
import HistoryFilter from './HistoryFilter';
import AskIslamFilters from './AskIslamFilters';
import GermanFilters from './GermanFilters';
import UrduFilters from './UrduFilters';
import NamePeriodicalsFilters from './NamePeriodicalsFilters';
import MTMMaterialFilters from './MTMMaterialFilters';
import ArabicMaterialFilters from './ArabicMaterialFilters';

// const tabTitle = {
//     'books':    'Jamati Books',
//     'ror':      'Review of Religions',
//     'alfazal':  'Al-Fazal',
//     'engBooks': 'English Jamaat Books',
//     'arabicBooks': 'Arabic Books',
//     'holyQuran': 'The Holy Quran',
//     'fridaySermon': 'Friday Sermon'
// }

const modalContents = {
    'books':    <UrduFilters />,
    'engBooks': <EngBooks />,
    'arabicBooks': <ArabicMaterialFilters />,
    'fridaySermon':<FridaySermonFilters/>,
    'history':<HistoryFilter/>,
    'askislam':<AskIslamFilters/>,
    'mtmMaterial':<MTMMaterialFilters/>,
    'germanBooks':<GermanFilters/>,
    'periodicals':<NamePeriodicalsFilters/>
}

class FiltersModal extends Component{
    static contextType = LocalizationContext;
    render(){
        const {language}=this.context;
        const tabTitle=langdata[language]['filtersTitle'];
        const {toggleModal, isOpen, tab} = this.props

        return isOpen ? (
                <BaseModal 
                handleClose={() => toggleModal(false)} 
                isOpen={isOpen} 
                content={modalContents[tab]} 
                title={tabTitle[tab]} 
                titlePosition="top"/>
                ) : null
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleModal: value => dispatch(toggleModalAction(value)),
    }
}

const mapStateToProps = (state) => {
    return { 
        isOpen: state.filters.isOpen,
        tab: state.filters.tab
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltersModal);
